import React from 'react';

class NoResultsMessage extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="container">
        <h3><img style={{verticalAlign: 'middle', marginRight: '10px', marginTop: '-30px'}} height="40px" src="https://static.thenounproject.com/png/604182-200.png" />Seleziona filtri o ricerca per iniziare.</h3>
      </div>
    );
  }
}

export default NoResultsMessage;


// WEBPACK FOOTER //
// ./src/components/shared/NoResultsMessage.js